import { createAction } from '@ngrx/store';

enum NewPaymentActionTypes {
  Init = '[NewPayment] Init',
}

export const init = createAction(NewPaymentActionTypes.Init);
